import React from "react";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content-clean">
          <div className="footer-brand-center">
            <h3>NARMADA SOLAR SOLUTIONS</h3>
            <p>(Your trusted partner for sustainable solar energy solutions)</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>
            &copy; {new Date().getFullYear()} NARMADA SOLAR SOLUTIONS. All rights reserved.
          </p>
          <p>
            Built with ❤️ by AM | Version 1.1.0
          </p>
        </div>
      </div>
    </footer>
  );
}
